import { isNodeChatAlreadyExists } from './globalHelper';
import { isChatCardClicked } from './chat-bot-live-helper';

const Mutation = {

  checkForBodyExistence(callbackFn, documentMutationObserver) {
    if (document.body) {
      callbackFn(documentMutationObserver);
    }
  },

  /**
 *
 * The function waitForBodyToLoad() monitors for `document.body to` exist.
 * It does NOT mean that the DOM has loaded, it only means that `document.body` has been created.
 *
 */
  waitForBodyToLoad(callback) {
    /*  In the event that `document.body` element doesn't exist, lets set up a mutation observer inside `document.documentElement`,
      and each time it's triggered, check for document.body.
  */
    const documentMutationObserver = new MutationObserver(() => {
      Mutation.checkForBodyExistence(callback, documentMutationObserver);
    });

    documentMutationObserver.observe(document.documentElement, { childList: true, subtree: true });

    // Lets call this once, just in case  that the document.body  exists
    Mutation.checkForBodyExistence(callback, documentMutationObserver);
  },

  // mutation observer to observe whether chat window is open or not to show the chat prompt.
  nodeChatObserver(documentMutationObserver) { // eslint-disable-line class-methods-use-this
    const targetNode = document.getElementById('node-chat');
    if (targetNode) {
      documentMutationObserver.disconnect(); // Lets stop observing the document node root element.
      const config = { attributes: true, attributeFilter: ['style'], childList: true };
      const observer = new MutationObserver((mutations) => {
        mutations.forEach(() => {
          const chatNowBtn = document.getElementById('chat-now-btn');
          const chatCard = document.getElementById('chat-question-card');
          if (isNodeChatAlreadyExists(targetNode)) {
            if (chatCard) {
              chatCard.style.display = 'none';
            }
            if (chatNowBtn) {
              chatNowBtn.style.display = 'none';
            }
            // Only if chat card is clicked change chat-btn(blue pill) css
          } else if ((isChatCardClicked() && chatNowBtn && !isNodeChatAlreadyExists(targetNode))) {
            chatNowBtn.style.display = 'block';
            chatNowBtn.style.position = 'relative';
            chatNowBtn.style.visibility = 'visible';
            chatNowBtn.style.opacity = '1';
          }
        });
      });
      observer.observe(targetNode, config);
    }
  },

};
export default Mutation;
